import React from 'react';
import { AppBar, Toolbar, Typography } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { useSelector } from 'react-redux';

const FooterLayout = () => {
	const currentYear = new Date().getFullYear();
	const footerTheme = useSelector(({ fuse }) => fuse.settings.footerTheme);
	const role = useSelector(({ auth }) => auth.user.role);

	return (
		<ThemeProvider theme={footerTheme}>
			{role.length !== 0 && (
				<AppBar id="fuse-footer" className="relative z-10" color="default">
					<Toolbar className="px-16 py-0 flex items-center justify-end">
						<Typography style={{ color: '#9ca3af' }}>Copyright © {currentYear}. Adaptive Computing Enterprises, Inc., All rights reserved.</Typography>
					</Toolbar>
				</AppBar>
			)}
		</ThemeProvider>
	);
};

export default FooterLayout;
